var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coach-prove-2023"},[_c('img',{attrs:{"src":_vm.$store.state.coachProve.bg,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }